import { render, staticRenderFns } from "./EventAppointments.vue?vue&type=template&id=b2af2c56&scoped=true&"
import script from "./EventAppointments.vue?vue&type=script&lang=js&"
export * from "./EventAppointments.vue?vue&type=script&lang=js&"
import style0 from "./EventAppointments.vue?vue&type=style&index=0&id=b2af2c56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2af2c56",
  null
  
)

export default component.exports